import React from "react";

const Contact = () =>{
    return(
        <div>
            <h2>Nous contacter</h2>
        </div>
    )
}

export default Contact;